// extracted by mini-css-extract-plugin
export default {"container":"ScreenSaver_container__sN2bZ"};